/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.enableInputWrapper = function(el) {
  const $el = $(el);
  $el.show();
  $el.find('input, select, textarea').prop('disabled', '');
};

root.disableInputWrapper = function(el) {
  const $el = $(el);
  $el.hide();
  $el.find('input, select, textarea').prop('disabled', 'disabled');
};

root.enableInput = function(el) {
  const $el = $(el);
  $el.parents('.input').first().slideDown();
  return $el.prop('disabled', '');
};

root.disableInput = function(el) {
  const $el = $(el);
  $el.parents('.input').first().slideUp();
  return $el.prop('disabled', '');
};

root.strip = function(html) {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

root.presence = function(s) {
  if (s && ($.trim(s).length > 0)) {
    return $.trim(s);
  } else {
    return null;
  }
};

root.endsWith = (str, suffix) => str.indexOf(suffix, str.length - suffix.length) !== -1;

root.scrollTo = function(id) {
  let elmt = $('#' + id)[0];
  if (elmt === undefined) {
    elmt = $('a[name="' + id + '"]')[0];
  }
  const $elmt = $(elmt);
  const height = $(window).height();
  const offset = $elmt.offset();
  if (offset) {
    const y = offset.top;
    const target = y; //- (height / 3)
    return $('html, body').animate({scrollTop: target}, 800);
  }
};

root.scrollToElement = function(elmt) {
  const height = $(window).height();
  const y = elmt.offset().top;
  const target = y - (height / 3);
  return $('html, body').animate({scrollTop: target}, 1000);
};

root.checkboxValues = function(selector) {
  const values = new Array;
  $.each($(selector + ':checked'), function() {
    return values.push($(this).val());
  });
  return values;
};

root.showTooltip = (el, content) => $(el).tooltipster({
  contentAsHTML: true,
  content,
  interactive: true,
  interactiveTolerance: 1000
});

root.showTempTooltip = function(el, content) {
  $(el).tooltipster({content}).tooltipster('show');
  return window.setTimeout((() => $(el).tooltipster('hide')), 1000);
};

root.navigateToQuestionAnchor = function(index) {
  const anchor = window.location.hash;
  const questionAnchor = "#Q" + (index + 1);
  if ($(anchor).length > 0) {
    const stickyOffset = $('.sticky-header-wrapper').outerHeight() || 0;
    return window.setTimeout((() => $('html, body').animate({ scrollTop: $(anchor).offset().top - stickyOffset }, 1000)), 1000);
  }
};

root.titleCase = function(str) {
  const words = str.toLowerCase().split(' ');
  let i = 0;
  while (i < words.length) {
    var letters = words[i].split('');
    letters[0] = letters[0].toUpperCase();
    words[i] = letters.join('');
    i++;
  }
  return words.join(' ');
};

Number.prototype.clamp = function(min, max) { if (max == null) { max = Infinity; } return Math.min(Math.max(this, min), max); };

$.fn.redraw = function() {
  return $(this).each(function() {
    const redraw = this.offsetHeight;
  });
};

$(document).ajaxStart(function() { if (!window.DISABLE_ANIMATIONS && !window.DISABLE_AJAX_LOADER) { return $('#loading').fadeIn(); } });
$(document).ajaxStop(function() { if (!window.DISABLE_ANIMATIONS && !window.DISABLE_AJAX_LOADER) { return $('#loading').fadeOut(); } });
document.addEventListener('ajax:complete', function() {
  if (!window.DISABLE_ANIMATIONS && !window.DISABLE_AJAX_LOADER) { $('#loading').hide(); }
});
// A request flagged `sessionExpiredRedirect` (survey_slider.js) handles its own
// 401 by sending the voter to the survey's session-expired notice instead.
$(document).ajaxError(function(e, error, settings) {
  if (error.status === 401 && !settings.sessionExpiredRedirect) {
    location.reload();
  }
});
